import {IconSource} from "./shared/enums/iconSource";
import {RoutePaths} from "./shared/routePaths";
import {AppAbilityType} from "./utils/auth/authorisation/authorisation";

export interface IRoute {
  name: string;
  to: string;
  exact?: boolean;
  icon?: IconSource;
  canBeAccessed?: (appAbility: AppAbilityType) => boolean;
}

export const homeRoute: IRoute = {
  name: "Home",
  to: RoutePaths.Home,
  exact: true,
  icon: IconSource.home
};

export const eventsRoute: IRoute = {
  name: "titles.events",
  to: RoutePaths.Events,
  exact: false,
  icon: IconSource.calendar
};

export const noticesRoute: IRoute = {
  name: "titles.notices",
  to: RoutePaths.Notices,
  exact: false,
  icon: IconSource.updates,
  canBeAccessed: (appAbility) =>
    appAbility.can("Read", "Notice") ||
    appAbility.can("Create", "Notice") ||
    appAbility.can("Update", "Notice") ||
    appAbility.can("Delete", "Notice")
};

export const residentAdminRoute: IRoute = {
  name: "titles.residents",
  to: RoutePaths.ResidentAdmin,
  exact: true,
  icon: IconSource.residents,
  canBeAccessed: (appAbility) =>
    appAbility.can("Read", "ResidentAdmin") ||
    appAbility.can("Create", "ResidentAdmin") ||
    appAbility.can("Update", "ResidentAdmin") ||
    appAbility.can("Delete", "ResidentAdmin")
};

export const transactionsRoute: IRoute = {
  name: "titles.transactions",
  to: RoutePaths.Transactions,
  exact: true,
  icon: IconSource.dollarTag,
  canBeAccessed: (appAbility) => appAbility.can("Read", "ProcessedBooking")
};

export const eventCatalogueRoute: IRoute = {
  name: "titles.eventCatalogues",
  to: RoutePaths.EventCatalogue,
  exact: false,
  icon: IconSource.catalogue,
  canBeAccessed: (appAbility) =>
    appAbility.can("Create", "EventCatalogue") ||
    appAbility.can("Update", "EventCatalogue") ||
    appAbility.can("Delete", "EventCatalogue")
};

export const specialDaysRoute: IRoute = {
  name: "titles.specialDays",
  to: RoutePaths.SpecialDays,
  exact: false,
  icon: IconSource.specialDay,
  canBeAccessed: (appAbility) =>
    appAbility.can("Create", "Occasion") ||
    appAbility.can("Update", "Occasion") ||
    appAbility.can("Delete", "Occasion")
};

export const metricsRoute: IRoute = {
  name: "Metrics",
  to: RoutePaths.Metrics,
  exact: false,
  icon: IconSource.metrics,
  canBeAccessed: (appAbility) => appAbility.can("Read", "Metrics")
};

/**
 * Village calendars admin route. Not in the exported default array because it
 * is linked from HeadOfficeMenuSection and gated by SuperUserRoute in App.tsx.
 */
export const villageCalendarsRoute: IRoute = {
  name: "titles.villageCalendars",
  to: RoutePaths.VillageCalendars,
  exact: false,
  icon: IconSource.calendar
};

const exports = [
  eventsRoute,
  noticesRoute,
  residentAdminRoute,
  transactionsRoute
];
export default exports;
